<div class="flex pb-0 pt-[0px] overflow-hidden">
  <div class="w-[98%]">
    <div class="flex justify-between items-center pl-[20px]">
      <div class="flex space-x-10">
        <h1 class="!text-[20px] pt-[10px] !font-bold !text-[#21252A] Roboto">
          PORTFOLIO
        </h1>

        <button
          class="!text-[14px] font-bold !text-[#21252A] !pt-[30px] !h-[55px]"
          [class.active]="selectedItem === 'Projects'"
          (click)="selectItem('Projects')"
        >
          Projects
        </button>
        <button
          class="!text-[14px] font-bold !text-[#21252A] !pt-[30px] !h-[55px]"
          [class.active]="selectedItem === 'Executive Dashboard'"
          (click)="selectItem('Executive Dashboard')"
        >
          Executive Dashboard
        </button>
        <button
          class="!text-[14px] font-bold !text-[#21252A] !pt-[30px] !h-[55px]"
          [class.active]="selectedItem === 'My Open Items'"
          (click)="selectItem('My Open Items')"
        >
          My Open Items
        </button>
        <button
          class="!text-[14px] font-bold !text-[#21252A] !pt-[30px] !h-[55px]"
          [class.active]="selectedItem === 'Financial Views'"
          (click)="selectItem('Financial Views')"
        >
          Financial Views
        </button>
      </div>

      <div>
        <button
          class="flex bg-white w-[5.208vw] justify-center align-middle !border !border-black rounded-md py-2 !text-[14px] font-bold text-gray-700"
        >
          Export
          <svg
            width="11"
            height="5"
            viewBox="0 0 11 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mt-[10px] ml-[5px]"
          >
            <path d="M0 0L5.1461 5L10.2922 0H0Z" fill="#343A40" />
          </svg>
        </button>
      </div>
    </div>

    <app-filter-tool
      [groupByOptions]="['None', 'Category', 'Date']"
      [statusOptions]="['Active', 'Inactive']"
      (search)="handleSearch($event)"
      (clearAll)="handleClearAll()"
      (viewType)="viewType($event)"
    ></app-filter-tool>
    <!-- List View for Projects -->
    <div
      *ngIf="viewMode === 'list'"
      class="table-container mt-[0px]"
      style="
        max-height: calc(90vh - 170px);
        overflow-y: auto;
        border: 1px solid #ddd;
      "
    >
      <table class="table-fixed w-full table-striped">
        <thead class="h-[50px] w-full !z-30 sticky top-0 bg-[#1A4971]">
          <tr
            class="bg-muted text-muted-foreground text-[#343A40] bg-[#DEE2E6]"
          >
            <th class="p-2 pl-[2rem] !font-Roboto !text-left">Project ID</th>
            <th class="p-2 !font-Roboto !text-left">Title</th>
            <th class="p-2 !text-left">Location</th>
            <th class="p-2 !text-center">Start Date</th>
            <th class="p-2 !text-left">Status</th>
            <th class="p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="fetchedProjects && fetchedProjects?.length > 0">
            <tr
              *ngFor="let project of filteredProjects; let i = index"
              class="hover:bg-muted/50 font-bold !font-Roboto !cursor-default"
            >
              <td
                (click)="openProject(project)"
                class="border-b p-2 pl-[2rem] !text-left cursor-pointer"
              >
                {{ project?.project_name_id }}
              </td>
              <td class="border-b p-2 !text-left">
                {{ project?.name }}
              </td>
              <td
                class="border-b p-2 !text-left cursor-pointer"
                (click)="openMapDialog(project?.longitude, project?.latitude)"
              >
                {{ getLocation(project) }}
              </td>
              <td class="border-b p-2 !text-center">
                {{ project?.start_date | date : "d/M/y" }}
              </td>
              <td class="border-b p-2 !text-left">Project Brief</td>
              <td class="border-b p-2">
                <button mat-button [matMenuTriggerFor]="menu">
                  <img
                    src="assets/icons/action_icon.svg"
                    alt="action icon"
                    class=""
                  />
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="handleEdit(project?.id)">
                    <mat-icon style="color: #e76b3f">edit</mat-icon>
                    <span>Edit</span>
                  </button>
                  <button mat-menu-item (click)="deleteProject(project)">
                    <mat-icon style="color: #e76b3f">delete</mat-icon>
                    <span>Delete</span>
                  </button>
                  <button mat-menu-item (click)="openProject(project)">
                    <mat-icon style="color: #e76b3f">visibility</mat-icon>
                    <span>View Details</span>
                  </button>
                  <button mat-menu-item (click)="openHistory(project)">
                    <mat-icon style="color: #e76b3f">search</mat-icon>
                    <span>View History</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </ng-container>
          <!-- EOI Initiated Request -->
          <ng-container
            *ngIf="requestedprojects && requestedprojects?.length > 0"
          >
            <tr
              *ngFor="let requestedProject of requestedprojects; let i = index"
              class="hover:bg-muted/50 font-bold !font-Roboto !cursor-default"
            >
              <td
                (click)="navigateToRequestedProject(requestedProject)"
                class="border-b p-2 pl-[2rem] !text-left cursor-pointer"
              >
                {{ requestedProject?.project_name_id }}
              </td>
              <td class="border-b p-2 !text-left">
                {{ requestedProject?.name }}
              </td>
              <td
                class="border-b p-2 !text-left"
                (click)="
                  openMapDialog(
                    requestedProject?.longitude,
                    requestedProject?.latitude
                  )
                "
              >
                {{ requestedProject?.street }}
                <span class="text-xs text-blue-500 cursor-pointer"
                  >(Preview)</span
                >
              </td>
              <td class="border-b p-2 !text-center">
                {{ requestedProject?.start_date | date : "d/M/y" }}
              </td>
              <td class="border-b p-2 !text-left">Project Brief</td>
              <td class="border-b p-2 !text-center"></td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <!-- Grid View for Projects -->
    <div
      class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-3 mt-4 pl-5"
      *ngIf="viewMode === 'grid'"
    >
      <!-- Iterate through Projects -->
      <ng-container *ngIf="fetchedProjects && fetchedProjects?.length > 0">
        <div
          *ngFor="let project of filteredProjects"
          class="bg-white border rounded-lg shadow-md hover:shadow-lg cursor-pointer"
          (click)="openProject(project)"
        >
          <div class="flex">
            <div class="p-4 pl-0 pt-0">
              <img
                src="
               assets/images/home_bg.jpeg
              "
                alt="File Preview"
                class="object-cover w-[80px] h-[113px] cursor-pointer"
              />
            </div>
            <div>
              <h3
                class="!text-[11px] mb-0 !font-medium text-[#21252A] !leading-normal"
              >
                {{ project?.name }}
              </h3>
              <p class="!text-[11px] text-gray-600 !leading-normal">
                {{ truncateDescription(project?.description) }}
              </p>
              <p class="!text-[11px] text-gray-500 mt-2 !leading-normal">
                {{ project?.start_date | date : "d/M/y" }}
              </p>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Requested Projects -->
      <ng-container *ngIf="requestedprojects && requestedprojects?.length > 0">
        <div
          *ngFor="let requestedProject of requestedprojects"
          class="bg-white border rounded-lg shadow-md hover:shadow-lg cursor-pointer"
          (click)="navigateToRequestedProject(requestedProject)"
        >
          <div class="p-4">
            <h3 class="!text-[11px] font-bold text-[#21252A]">
              {{ requestedProject?.name }}
            </h3>
            <p class="!text-[11px] text-gray-600">
              {{ requestedProject?.street }}
            </p>
            <p class="!text-[11px] text-gray-500">
              {{ requestedProject?.start_date | date : "d/M/y" }}
            </p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="mt-[20px] flex !pt-0 p-[57px] !pb-0 mb-[0rem] justify-between">
    <button
      (click)="createNewProject()"
      class="!bg-[#E76B3F] !text-[#ffffff] !text-[14px] flex h-[46px] justify-center items-center flex-shrink-0 hover:bg-white rounded-[3px] shadow-md ml-[15px] text-center"
      style="padding: 14px 24px; font-weight: 600"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clip-path="url(#clip0_5810_47932)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 0C5.38125 0 0 5.38125 0 12C0 18.6187 5.38125 24 12 24C18.6187 24 24 18.6187 24 12C24 5.38125 18.6187 0 12 0Z"
            fill="#E76B3F"
          />
          <path
            d="M5.4375 13.107V10.8898C5.4375 10.6648 5.62031 10.4773 5.85 10.4773H10.4859V5.84609C10.4859 5.62109 10.6687 5.43359 10.8984 5.43359H13.1156C13.3406 5.43359 13.5234 5.61641 13.5234 5.84609V10.482H18.1547C18.3797 10.482 18.5672 10.6648 18.5672 10.8945V13.1117C18.5672 13.3367 18.3844 13.5195 18.1547 13.5195H13.5187V18.1508C13.5187 18.3758 13.3359 18.5633 13.1109 18.5633H10.8937C10.6687 18.5633 10.4813 18.3805 10.4813 18.1508V13.5148H5.85C5.62031 13.5195 5.4375 13.332 5.4375 13.107Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_5810_47932">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      Create New Project
    </button>
  </div>
  <!-- Pagination Controls -->
  <!-- <div class="flex justify-end items-center mt-4 !mb-8">
    <button
      (click)="previousPage()"
      [disabled]="currentPage === 1"
      class="px-4 py-2 p-4 w-28 bg-[#4287f5] mr-[15px] font-semibold text-black rounded hover:bg-gray-400"
    >
      Previous
    </button>
    <span>Page {{ currentPage }} of {{ totalPages }}</span>
    <button
      (click)="nextPage()"
      [disabled]="currentPage === totalPages"
      class="px-4 py-2 w-28 ml-[15px] font-semibold bg-[#4287f5] text-black rounded hover:bg-gray-400"
    >
      Next
    </button>
  </div> -->
</div>

<ng-container *ngIf="isProjectEdit || isProjectOpen">
  <app-project-wrapper></app-project-wrapper>
</ng-container>
